<div class="chat">
	<div class="chat-message-list">
		@for (message of messageList(); track message) {
			<div
				class="chat-message"
				[class.current-user]="message.isCurrentUser"
				[class.action]="!!message.actionType"
			>
				<!-- <p-avatar
				[image]="message.image"
				[label]="!message.image ? message.capName : ''"
				[ngClass]="{
					'bg-primary-100 text-primary-950': !message.image
				}"
				styleClass="w-10 h-10 text-sm font-medium"
				shape="circle"
				/> -->
				<div class="chat-message-container">
					<svg
						class="chat-message-arrow"
						xmlns="http://www.w3.org/2000/svg"
						width="7"
						height="11"
						viewBox="0 0 7 11"
						fill="none"
					>
						<path
							d="M1.79256 7.09551C0.516424 6.31565 0.516426 4.46224 1.79256 3.68238L7 0.500055L7 10.2778L1.79256 7.09551Z"
						/>
					</svg>
					<div class="chat-message-content">
						@if (
							!message.isCurrentUser && message.message.userIdAndName.userId
						) {
							<p class="chat-message-sender">
								{{
									message.message.userIdAndName.name ||
										'User ' + message.message.userIdAndName.userId
								}}
							</p>
						}
						@if (message.message.actionType) {
							<div
								class="chat-action chat-action-{{ message.message.actionType }}"
							>
								@if (message.message.actionIcon) {
									<mat-icon>{{ message.message.actionIcon }}</mat-icon>
								}
								<span>{{ message.message.actionName }}</span>
							</div>
						}
						@if (message.message.isHtml) {
							<p
								class="chat-message-text"
								[innerHTML]="message.message.message | sanitizeHtml"
							></p>
						} @else {
							<p class="chat-message-text">{{ message.message.message }}</p>
						}
						@for (attachment of message.message.attachments; track attachment) {
							<div
								:class="!message.isCurrentUser ? 'bg-surface-200 dark:bg-surface-700' : 'bg-primary-emphasis'"
								class="mt-2 w-full rounded-lg mb-0.5 hover:opacity-75 transition-all"
							>
								<!-- <img class="w-full h-auto block cursor-pointer" [src]="message.attachment" alt="Message Image" /> -->
							</div>
						}
						<p class="chat-message-timestamp">
							{{ message.message.timestamp | date: 'dd.MM.yyyy HH:mm' }}
						</p>
					</div>
				</div>
			</div>
		}
	</div>
	<div class="chat-new-message">
		<div
			#newMessage
			contenteditable
			class="chat-new-message-input"
			rows="1"
			placeholder="Type a message..."
			(keydown.control.enter)="sendMessage()"
			class="chat-new-message-input"
			[mentionConfig]="mentionConfig()"
			(searchTerm)="userSearchQuery.set($event)"
		></div>
		<button
			class="chat-new-message-send"
			mat-icon-button
			mat-medium-icon-button
			(click)="sendMessage()"
		>
			<mat-icon>send</mat-icon>
		</button>
	</div>
</div>
